import { Checkbox, FormControlLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  input: {
    padding: "0px",
  },
  checkboxContainer: {
    display: "flex",
    justifyContent: "flex-start",
    "& .MuiFormControlLabel-label": {
      color: "#fff",
      marginLeft: "16px",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      "&.Mui-disabled": {
        color: "#fff",
      },
    },
    "& .MuiFormControlLabel-root": {
      margin: 0,
      "&.Mui-disabled": {
        opacity: 0.5,
      },
    },
    "& .MuiCheckbox-root": {
      padding: "4px 4px 4px 0",
    },
    "& .MuiCheckbox-root .MuiSvgIcon-root": {
      fill: "#757575",
      fontSize: "16px",
    },
    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
      fill: "#F50561",
    },
  },
});

export default function FormCheckboxFieldDark(props) {
  const { label, checked, disabled = false, onChange, ...rest } = props;

  const classes = useStyles();

  return (
    <div className={classes.checkboxContainer}>
      <FormControlLabel
        control={<Checkbox checked={checked} disabled={disabled} />}
        label={label}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
}
